import { httpInstance } from '../../api'
import * as types from '../mutation-types'

const state = {
  divisions: [],
  activeDivision: {},
  plants: [],
  activePlant: {},
  departments: [],
  activeDepartment: {},
  companies: [],
  activeCompany: {},
  ranks: [],
  activeRank: {},
  httpResponse: {},
  loading: false,
  currency: []
}

const getters = {
  getResponse: state => state.httpResponse,
  getLoading: state => state.loading,

  getAllCompanies: state => state.companies,
  getActiveCompany: state => state.activeCompany,

  getAllDivisions: state => state.divisions,
  getActiveDivision: state => state.activeDivision,

  getAllDepartments: state => state.departments,
  getActiveDepartment: state => state.activeDepartment,

  getAllRanks: state => state.ranks,
  getActiveRank: state => state.activeRank,

  getAllPlants: state => state.plants,
  getActivePlant: state => state.activePlant,

  getCurrency: state => state.currency
}

const mutations = {
  [types.LOAD_RESPONSE](state, payload) {
    state.httpResponse = payload
  },
  [types.SET_LOADING](state, payload) {
    state.loading = payload
  },

  [types.GET_ALL_COMPANIES](state, payload) {
    state.companies = payload
  },

  [types.ADD_COMPANY](state, payload) {
    state.companies.push(payload)
  },

  [types.CHANGE_COMPANY](state, payload) {
    let atIndex = state.companies.findIndex(c => c.id === payload.id)
    state.companies.splice(atIndex, 1)
    state.companies.splice(atIndex, 0, payload)
  },

  [types.DELETE_COMPANY](state, payload) {
    let atIndex = state.divisions.findIndex(d => d.id === payload)
    state.divisions.splice(atIndex, 1)
  },

  [types.SET_ACTIVE_COMPANY](state, payload) {
    state.activeCompany = payload
  },

  [types.ADD_DIVISION](state, { payload }) {
    state.divisions.push(payload)
  },
  [types.GET_ALL_DIVISIONS](state, payload) {
    state.divisions = payload
  },
  [types.CHANGE_DIVISION](state, payload) {
    let atIndex = state.divisions.findIndex(d => d.id === payload.id)
    state.divisions.splice(atIndex, 1)
    state.divisions.splice(atIndex, 0, payload)
  },
  [types.DELETE_DIVISION](state, payload) {
    let atIndex = state.divisions.findIndex(d => d.id === payload)
    state.divisions.splice(atIndex, 1)
  },
  [types.SET_ACTIVE_DIVISION](state, payload) {
    state.activeDivision = payload
  },

  [types.ADD_DEPARTMENT](state, { payload }) {
    state.departments.push(payload)
  },
  [types.GET_ALL_DEPARTMENTS](state, payload) {
    state.departments = payload
  },
  [types.CHANGE_DEPARTMENT](state, payload) {
    let atIndex = state.departments.findIndex(d => d.id === payload.id)
    state.departments.splice(atIndex, 1)
    state.departments.splice(atIndex, 0, payload)
  },
  [types.DELETE_DEPARTMENT](state, payload) {
    let atIndex = state.departments.findIndex(d => d.id === payload)
    state.departments.splice(atIndex, 1)
  },
  [types.SET_ACTIVE_DEPARTMENT](state, payload) {
    state.activeDepartment = payload
  },

  [types.ADD_RANK](state, { payload }) {
    state.ranks.push(payload)
  },
  [types.GET_ALL_RANKS](state, payload) {
    state.ranks = payload
  },
  [types.CHANGE_RANK](state, payload) {
    let atIndex = state.ranks.findIndex(rank => rank.id === payload.id)
    state.ranks.splice(atIndex, 1)
    state.ranks.splice(atIndex, 0, payload)
  },
  [types.DELETE_RANK](state, payload) {
    let atIndex = state.ranks.findIndex(rank => rank.id === payload)
    state.ranks.splice(atIndex, 1)
  },
  [types.SET_ACTIVE_RANK](state, payload) {
    state.activeRank = payload
  },

  [types.ADD_PLANT](state, { payload }) {
    state.plants.push(payload)
  },
  [types.GET_ALL_PLANTS](state, payload) {
    state.plants = payload
  },
  [types.CHANGE_PLANT](state, payload) {
    let atIndex = state.plants.findIndex(plant => plant.id === payload.id)
    state.plants.splice(atIndex, 1)
    state.plants.splice(atIndex, 0, payload)
  },
  [types.DELETE_PLANT](state, payload) {
    let atIndex = state.plants.findIndex(plant => plant.id === payload)
    state.plants.splice(atIndex, 1)
  },
  [types.SET_ACTIVE_PLANT](state, payload) {
    state.activePlant = payload
  },
  [types.GET_CURRENCY](state, payload) {
    state.currency = payload
  },
  [types.CHANGE_CURRENCY](state, payload) {
    let atIndex = state.currency.findIndex(c => c.id === payload.id)
    state.currency.splice(atIndex, 1)
    state.currency.splice(atIndex, 0, payload)
  },
  [types.DELETE_CURRENCY](state, payload) {
    let atIndex = state.currency.findIndex(c => c.id === payload)
    state.currency.splice(atIndex, 1)
  }
}

const actions = {
  async fetchAllCompanies({ commit }) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get('/company/list-unlimited')
      .then(response => {
        commit(types.GET_ALL_COMPANIES, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async addCompany({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .post('/company/add', payload)
      .then(response => {
        commit(types.ADD_COMPANY, payload)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async changeCompany({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .put(`/company/${payload.id}/update`, payload)
      .then(response => {
        commit(types.CHANGE_COMPANY, payload)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async setActiveCompany({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get(`/company/${id}/get`)
      .then(response => {
        commit(types.SET_ACTIVE_COMPANY, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async fetchAllDivisions({ commit }) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get('/division/list-unlimited')
      .then(response => {
        commit(types.GET_ALL_DIVISIONS, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async setActiveDivision({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get(`/division/${id}/get`)
      .then(response => {
        commit(types.SET_ACTIVE_DIVISION, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async changeDivision({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .put(`/division/${payload.id}/update`, {
        initial: payload.initial,
        description: payload.description
      })
      .then(response => {
        commit(types.CHANGE_DIVISION, payload)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async addNewDivision({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .post('/division/add', {
        initial: payload.initial,
        description: payload.description
      })
      .then(response => {
        commit(types.ADD_DIVISION, payload)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async deleteDivision({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .delete(`/division/${id}/delete`)
      .then(response => {
        commit(types.DELETE_DIVISION, id)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async fetchAllDepartments({ commit }) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get('/department/list-unlimited')
      .then(response => {
        commit(types.GET_ALL_DEPARTMENTS, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async setActiveDepartment({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get(`/department/${id}/get`)
      .then(response => {
        commit(types.SET_ACTIVE_DEPARTMENT, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async changeDepartment({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .put(`/department/${payload.id}/update`, {
        initial: payload.initial,
        description: payload.description
      })
      .then(response => {
        commit(types.CHANGE_DEPARTMENT, payload)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async addNewDepartment({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .post('/department/add', {
        initial: payload.initial,
        description: payload.description
      })
      .then(response => {
        commit(types.ADD_DEPARTMENT, payload)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async deleteDepartment({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .delete(`/department/${id}/delete`)
      .then(response => {
        commit(types.DELETE_DEPARTMENT, id)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async fetchAllRanks({ commit }) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get('/rank/list-unlimited')
      .then(response => {
        commit(types.GET_ALL_RANKS, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async setActiveRank({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get(`/rank/${id}/get`)
      .then(response => {
        commit(types.SET_ACTIVE_RANK, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async changeRank({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .put(`/rank/${payload.id}/update`, {
        description: payload.description,
        rank_initial: payload.rank_initial
      })
      .then(response => {
        commit(types.CHANGE_RANK, payload)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async addNewRank({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .post('/rank/add', {
        description: payload.description,
        rank_initial: payload.rank_initial
      })
      .then(response => {
        commit(types.ADD_RANK, payload)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async deleteRank({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .delete(`/rank/${id}/delete`)
      .then(response => {
        commit(types.DELETE_RANK, id)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        commit(types.LOAD_RESPONSE, error.response)
        console.log(error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async fetchAllPlants({ commit }) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get('/plant/list-unlimited')
      .then(response => {
        commit(types.GET_ALL_PLANTS, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        commit(types.SET_LOADING, false)
        commit(types.LOAD_RESPONSE, error.response)
      })
  },
  async setActivePlant({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .get(`/plant/${id}/get`)
      .then(response => {
        commit(types.SET_ACTIVE_PLANT, response.data)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.SET_LOADING, false)
        commit(types.LOAD_RESPONSE, error.response)
      })
  },
  async changePlant({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .put(`/plant/${payload.id}/update`, {
        plant: payload.plant,
        description: payload.description,
        company_code: payload.company_code
      })
      .then(response => {
        commit(types.CHANGE_PLANT, payload)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async addNewPlant({ commit }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .post('/plant/add', {
        plant: payload.plant,
        description: payload.description,
        company_code: payload.company_code
      })
      .then(response => {
        commit(types.ADD_PLANT, payload)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async deletePlant({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .delete(`/plant/${id}/delete`)
      .then(response => {
        commit(types.DELETE_PLANT, id)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async getAllCurrency({ commit }) {
    commit(types.SET_LOADING, true)
    await httpInstance.get(`/exchange-rate/list-unlimited`).then(response => {
      commit(types.SET_LOADING, false)
      commit(types.GET_CURRENCY, response.data)
    }).catch(error => {
      commit(types.SET_LOADING, false)
      commit(types.LOAD_RESPONSE, error.response)
    })
  },

  async addCurrency({ commit, dispatch }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .post('/exchange-rate/create', {
        company_code: payload.company_code,
        from_currency_code: payload.from_currency_code,
        to_currency_code: payload.to_currency_code,
        rate: payload.rate,
        valid_from_date: payload.valid_from_date,
        valid_to_date: payload.valid_to_date
      })
      .then(response => {
        dispatch('getAllCurrency')
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async changeCurrency({ commit, dispatch }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .put(`/exchange-rate/${payload.id}/update`, {
        company_code: payload.company_code,
        from_currency_code: payload.from_currency_code,
        to_currency_code: payload.to_currency_code,
        rate: payload.rate,
        valid_from_date: payload.valid_from_date,
        valid_to_date: payload.valid_to_date
      })
      .then(response => {
        dispatch('getAllCurrency')
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },
  async deleteCurrency ({ commit }, id) {
    commit(types.SET_LOADING, true)
    await httpInstance.delete(`/exchange-rate/${id}/delete`).then(response => {
      commit(types.DELETE_CURRENCY, id)
      commit(types.LOAD_RESPONSE, response)
      commit(types.SET_LOADING, false)
    }).catch(error => {
      commit(types.LOAD_RESPONSE, error.response)
      commit(types.SET_LOADING, false)
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/master-data.js